import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Row = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
}));
